import { Link } from 'react-router-dom';
import { DocSection, Callout } from '../../../pages/shell';

export const toc = [
  { id: 'video', label: 'Video' },
  { id: 'images', label: 'Images' },
  { id: 'not-supported', label: 'Not supported' },
];

export default function Body() {
  return (
    <>
      <DocSection id="video" title="Video">
        <p>
          ClipRadar imports and analyzes video files by extension. Anything outside this list
          won't show up in the file picker or get picked up from a watched folder:
        </p>
        <ul>
          <li><code>.mp4</code></li>
          <li><code>.mkv</code></li>
          <li><code>.avi</code></li>
          <li><code>.mov</code></li>
          <li><code>.webm</code></li>
          <li><code>.mxf</code></li>
          <li><code>.mts</code></li>
        </ul>
        <p>
          Every file in this list is eligible for all three analysis passes — Visual, Speech, and
          Faces. See{' '}
          <Link to="/docs/concepts/analyzing-media">Analyzing your footage</Link> for what each
          pass actually does.
        </p>
      </DocSection>

      <DocSection id="images" title="Images">
        <p>Stills are indexed the same way as a video scene — one embedding, searchable in Visuals and Ultra Search:</p>
        <ul>
          <li><code>.jpg</code></li>
          <li><code>.jpeg</code></li>
          <li><code>.png</code></li>
          <li><code>.webp</code></li>
          <li><code>.bmp</code></li>
          <li><code>.tif</code></li>
          <li><code>.tiff</code></li>
        </ul>
      </DocSection>

      <DocSection id="not-supported" title="Not supported">
        <Callout kind="warn">
          <code>.braw</code> (Blackmagic RAW), <code>.r3d</code> (RED RAW), ProRes RAW, and{' '}
          <code>.heic</code> are <strong>not supported</strong> — none of them are on the video or
          image lists above, and there's no partial or degraded mode for them.
        </Callout>
        <p>
          If footage arrives in one of these formats, transcode or export a proxy into a supported
          container first (an <code>.mp4</code> or <code>.mov</code> works) and add that copy to
          ClipRadar's library instead.
        </p>
      </DocSection>
    </>
  );
}
